import React from "react";
import SearchTable from "../../components/SearchTable";
import useWindowDimensions from "../../components/useWindowDimensions";



export default function StaticDiscipline(props) {

    const { width } = useWindowDimensions();

    const columns = [
        {
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
            width: (width>900)?200:150,
            sorter: true,
            align:'left',
            searchable: true,
            render: (text, record) => (
                <div style={{display:"flex", fontWeight:"bold"}}>
                    <div>
                        <div>{record.name}</div>
                    </div>
                </div>
            )
        },
        {
            title: 'Details',
            key: 'details',
            dataIndex: 'details',
            sorter: true,
            align: 'left',
            render: (text, record) => {
                return (
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {record.reason && (
                            <div>
                                <div>{record.reason}</div>
                            </div>
                        )}
                        {record.actions && record.actions.length > 0 && (
                            <div>
                                <div style={{fontWeight:"bold", marginTop:10}}>Actions</div>
                                <ul style={{listStyle:"disc", paddingLeft:20, marginTop:5}}>
                                    {record.actions.map((action, index) => (
                                        <li key={index}>{action}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                );
            }
        },
        {
            title: 'Date',
            key: 'date',
            dataIndex: 'date',
            width: (width>900)?150:100,
            align:'center',
            sorter: true,
            render: (text, record) => (
                <div>
                    {record.date ? new Date(record.date * 1000).toLocaleDateString('en-AU') : ''}
                </div>
            )
        },
    ];

    return (

		<div style={{margin:"70px 0"}}>
            <SearchTable
                columns={columns}
                data={[
                    {
                        name: 'Sim Sullivan',
                        reason: `Providing Services Outside Professional Scope of Practice
The practitioner was found to have provided clinical health services beyond the scope of sports nutrition practice, including interpreting blood profiles and diagnosing gut health conditions. Sports nutritionists are not authorized to provide clinical diagnostic services or medical interpretations without appropriate medical qualifications and licensing.
`,
                        actions: [
                            'Met with member to discuss breach of scope of practice'
                        ],
                        date: Date.parse("2023-01-18T00:00:00Z")/1000
                    },
                    {
                        name: 'Leah Carroll',
                        reason: `Providing Services Outside Professional Scope of Practice
The practitioner was found to have provided clinical health services beyond the scope of sports nutrition practice, including interpreting blood profiles and diagnosing gut health conditions. Sports nutritionists are not authorized to provide clinical diagnostic services or medical interpretations without appropriate medical qualifications and licensing.
`,
                        actions: [
                            'Contacted member January 2023 about scope of practice breach',
                            'Termination of registration and removal from registry'
                        ],
                        date: Date.parse("2023-03-13T00:00:00Z")/1000
                    },
                    {
                        name: 'Lachlan McFie',
                        reason: `Unauthorized Promotion of Performance Enhancing Drug (PED) Education
The practitioner was found to have provided education and advice regarding performance enhancing drugs without holding a medical license. The provision of PED-related guidance, including usage protocols, health monitoring, or harm reduction strategies, requires appropriate medical licensing and falls outside the scope of sports nutrition practice.
`,
                        actions: [
                            'Termination of registration and removal from registry'
                        ],
                        date: Date.parse("2024-11-19T00:00:00Z")/1000
                    },
                    {
                        name: 'Nicholas Weir',
                        reason: `Unauthorized Promotion of Performance Enhancing Drug (PED) Education
The practitioner was found to have provided education and advice regarding performance enhancing drugs without holding a medical license. The provision of PED-related guidance, including usage protocols, health monitoring, or harm reduction strategies, requires appropriate medical licensing and falls outside the scope of sports nutrition practice.
`,
                        actions: [
                            'Termination of registration and removal from registry'
                        ],
                        date: Date.parse("2024-10-24T00:00:00Z")/1000
                    }
                ]}
                style={{border:"1px solid #E0E0E0", borderRadius:"8px 8px 2px 2px"}}
            />
        </div>
	);
}